import React from 'react';

interface QuantityInputProps {
  step: number;
  value: number;
  onChange: (value: number) => void;
}

function QuantityInput({ step, value, onChange }: QuantityInputProps) {
  return (
    <div className=" w-32">
      <div className="flex flex-row h-[2.5rem] w-full rounded-lg relative bg-transparent mt-1">
        <button
          type="button"
          className=" border-y border-l text-gray-600  border-neutral-cold-400 h-full w-20 rounded-l cursor-pointer outline-none"
          onClick={(e) => {
            e.preventDefault();
            onChange(value - step);
          }}
        >
          <span className="m-auto text-2xl text-neutral-cold-400">−</span>
        </button>
        <span className="outline-none border-y border-neutral-cold-400 flex justify-center  focus:outline-none text-center w-full font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none">
          {value ?? 0}
        </span>

        <button
          type="button"
          className=" text-gray-600 border-y border-r border-neutral-cold-400  h-full w-20 rounded-r cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            onChange(value + step);
          }}
        >
          <span className="m-auto text-2xl text-neutral-cold-400 ">+</span>
        </button>
      </div>
    </div>
  );
}

export default QuantityInput;
